import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const CustomToast = withReactContent(
	Swal.mixin({
		toast: true,
		position: "top",
		customClass: {
			popup: "toast",
		},
		showConfirmButton: false,
		timer: 4000,
		timerProgressBar: false,
	}),
);

export const ErrorToast = CustomToast.mixin({
	customClass: { popup: "error" },
	timerProgressBar: true,
});

export const SuccessToast = CustomToast.mixin({
	customClass: { popup: "success" },
});

export const InfoToast = CustomToast.mixin({
	customClass: { popup: "info" },
    timerProgressBar: true,
});
